module.exports = __webpack_public_path__ + "static/media/masterclass_100.0c9fec0f.png";